import axios from 'axios';
import Resizer from 'react-image-file-resizer';
import cookie from 'react-cookies';
import { getErrorMessageFromResponse } from './errorUtils';
import {
  builderSurfaceJsonContentHeader,
  builderSurfaceMultiPartHeader,
} from './restApiHeaderUtils';
export const imageTypes = ['image/png', 'image/jpeg', 'image/gif'];
export const pwaImageTypes = ['image/png', 'image/svg', 'image/webp'];
export const eImageTypes = ['image/png', 'image/jpeg', 'image/jpg'];

const resizeFile = (file) => {
  const fileName = file.name;
  const fileExtension = fileName.replace(/^.*\./, '');
  return new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      192,
      192,
      fileExtension,
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      'file',
      192,
      192,
    );
  });
};

export async function getInstalledPlugins(iPlugins) {
  const fileActivityTrackerPlugin = iPlugins.find(
    (plugin) => plugin.code === 'FILE_ACTIVITY_TRACKER',
  );
  return !!fileActivityTrackerPlugin;
}

export function fileActivityTrackerLogs(activity, projectId, fileData, version) {
  const header = builderSurfaceJsonContentHeader(projectId);
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/file_activity_tracker/`;
  const userIp = cookie.load('userIp');
  const userName = cookie.load('username');
  let originalName;
  let collectionName;
  let collectionField;
  if (Array.isArray(fileData)) {
    originalName = fileData.map((file) => file.originalName).join(', ');
    collectionName = fileData[0].collectionName;
    collectionField = fileData[0].collectionField;
  } else {
    collectionName = fileData.collectionName;
    originalName = fileData.originalName;
    collectionField = fileData.collectionField;
  }

  const data = {
    activity: activity,
    collName: collectionName,
    collField: collectionField,
    fileName: originalName,
    ipAddress: userIp ? userIp : '',
    userId: userName ? userName : '',
  };
  axios.post(url, data, header).catch((err) => {
    console.log('Error in file tracking logs', err);
    throw err;
  });
}

async function uploadOnServer(
  projectId,
  endPoint,
  data,
  setFieldValue,
  field,
  setSubmitting,
  setErrors = null,
  setFieldTouched = null,
  version,
  plugins,
) {
  const header = builderSurfaceMultiPartHeader(projectId);
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}${endPoint}`;
  const isFileTrackerPluginExists = await getInstalledPlugins(plugins);
  const { isPrivate } = field;
  axios
    .post(url, data, header)
    .then((res) => {
      setFieldValue(field.fieldName, res.data);
      setSubmitting(false);
      if (isFileTrackerPluginExists === true && isPrivate === true) {
        fileActivityTrackerLogs('Upload', projectId, res.data, version);
      }
    })
    .catch((err) => {
      if (setErrors && setFieldTouched) {
        setFieldTouched(field.fieldName, true);
        setErrors({ [field.fieldName]: getErrorMessageFromResponse(err.response) });
      } else {
        setFieldValue(field.fieldName, []);
        setSubmitting(false);
      }
    });
}

export const uploadFileOnServer = (
  event,
  setFieldValue,
  field,
  collectionId,
  projectId,
  version,
  plugins,
  setSubmitting,
  setErrors = null,
  setFieldTouched = null,
) => {
  const data = new FormData();
  const fileData = event.currentTarget.files[0];
  data.append('file', fileData);
  let endpoint = `file/upload/${collectionId}/`;
  if (field.fieldName && field.fieldName.includes('.')) {
    const fieldNames = field.fieldName.split('.');
    endpoint = endpoint + fieldNames[1];
  } else {
    endpoint = endpoint + field.fieldName;
  }
  uploadOnServer(
    projectId,
    endpoint,
    data,
    setFieldValue,
    field,
    setSubmitting,
    setErrors,
    setFieldTouched,
    version,
    plugins,
  );
};

export const uploadPWAFileOnServer = async (
  event,
  setFieldValue,
  field,
  folderName,
  projectId,
  setSubmitting,
  version,
  plugins,
  setErrors = null,
  setFieldTouched = null,
) => {
  const data = new FormData();
  const fileData = event.currentTarget.files[0];
  const image = await resizeFile(fileData);
  data.append('file', image);
  let endpoint = `file/pwa-upload/${folderName}`;
  uploadOnServer(
    projectId,
    endpoint,
    data,
    setFieldValue,
    field,
    setSubmitting,
    setErrors,
    setFieldTouched,
    version,
    plugins,
  );
};

export const uploadMultipleFileOnServer = (
  event,
  setFieldValue,
  field,
  collectionId,
  projectId,
  version,
  plugins,
  setSubmitting,
  setErrors = null,
  setFieldTouched = null,
) => {
  let data = new FormData();
  for (let x = 0; x < event.currentTarget.files.length; x++) {
    data.append('files', event.currentTarget.files[x]);
  }
  let endpoint = `file/multi/upload/${collectionId}/`;
  if (field.fieldName && field.fieldName.includes('.')) {
    const fieldNames = field.fieldName.split('.');
    endpoint = endpoint + fieldNames[1];
  } else {
    endpoint = endpoint + field.fieldName;
  }
  uploadOnServer(
    projectId,
    endpoint,
    data,
    setFieldValue,
    field,
    setSubmitting,
    setErrors,
    setFieldTouched,
    version,
    plugins,
  );
};
